module.exports = __webpack_public_path__ + "static/media/yellow_card.7409d2b9.svg";